var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComputersAndOfficeSupplies = function SvgComputersAndOfficeSupplies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#computers-and-office-supplies_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 1.5h10c.275 0 .5.225.5.5v1H16V2c0-1.103-.897-2-2-2H4C2.897 0 2 .897 2 2v8H.5c-.275 0-.5.225-.5.5A1.5 1.5 0 0 0 1.5 12H11v-2H3.5V2c0-.275.225-.5.5-.5m8 13a1.5 1.5 0 0 0 1.5 1.5h5a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 18.5 4h-5A1.5 1.5 0 0 0 12 5.5zm6.5 0h-5v-9h5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "computers-and-office-supplies_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v16H0z"
  })))));
};
export default SvgComputersAndOfficeSupplies;